module.exports = __webpack_public_path__ + "img/app-2-dark.2e13b038.png";